<template>
  <UiSection id="participants" class="dark">
    <div class="container mx-auto space-y-10">
      <h2 class="text-4xl sm:text-5xl font-extrabold uppercase" v-text="t('header')" />

      <div v-if="players.length">
        <h3 class="flex flex-wrap items-end text-3xl font-extrabold">
          <span class="cursor-pointer mr-8 hover:text-gray-400" :class="active === 'all' ? 'text-gray-200' : 'text-gray-600'" @click="active = 'all'">
            {{ t('players') }}
            ({{ players.length }})
          </span>
          <span class="cursor-pointer mr-8 text-xl hover:text-gray-400" :class="active === 'duel' ? 'text-gray-200' : 'text-gray-600'" @click="active = 'duel'"> {{ t('duel') }} ({{ playersDuel.length }} {{ t('of') }} {{ limitDuel }}) </span>
          <span class="cursor-pointer mr-8 text-xl hover:text-gray-400" :class="active === 'draft' ? 'text-gray-200' : 'text-gray-600'" @click="active = 'draft'"> {{ t('draft') }} ({{ playersDraft.length }} {{ t('of') }} {{ limitDraft }}) </span>
        </h3>

        <transition-group name="participants" tag="div" class="relative flex flex-wrap my-4 -ml-4">
          <UiParticipant class="participants-item mb-4 ml-4 p-3 bg-gradient-to-br from-gray-600 to-gray-700" v-for="player in filteredPlayers" :key="player.nick" :info="player" />
        </transition-group>

        <div class="flex space-x-0 space-y-4 flex-col sm:flex-row sm:space-x-4 sm:space-y-0 sm:items-center">
          <UiButton class="bg-gradient-to-br from-orange-500 to-red-700 hover:from-yellow-500" v-text="t('signup')" @click="modals.signup = true" />
          <div class="text-base text-gray-600" v-html="t('requirements')" />
        </div>
      </div>

      <div v-if="spectators.length">
        <h3 class="text-3xl font-extrabold">{{ t('scpectators') }} ({{ spectators.length }} {{ t('of') }} 7)</h3>
        <div class="flex flex-wrap my-4 -ml-4">
          <UiParticipant class="mb-4 ml-4 p-3 bg-gradient-to-br from-gray-600 to-blue-800" v-for="(player, index) in spectators" :key="index" :info="player" />
        </div>
      </div>

      <div v-if="staff.length">
        <h3 class="text-3xl font-extrabold">{{ t('staff') }} ({{ staff.length }})</h3>
        <div class="flex flex-wrap my-4 -ml-4">
          <UiParticipant class="mb-4 ml-4 p-3 bg-gradient-to-br from-gray-600 to-red-900" v-for="(player, index) in staff" :key="index" :info="player" />
        </div>
      </div>
    </div>
  </UiSection>
</template>

<script>
  import { computed, ref } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { menu, modals, players, staff, spectators } from '../../store.js'

  export default {
    name: 'SectionParticipants',
    setup() {
      const limitDuel = 32
      const limitDraft = 40

      const active = ref('all')

      const playersDuel = computed(() => {
        return players.value.filter((player) => player.day1)
      })

      const playersDraft = computed(() => {
        return players.value.filter((player) => player.day2)
      })

      const filteredPlayers = computed(() => {
        if (active.value === 'duel') {
          return playersDuel.value
        }
        if (active.value === 'draft') {
          return playersDraft.value
        }
        return players.value
      })

      const { t } = useI18n({
        messages: {
          en: {
            header: 'Participants',
            staff: 'Staff',
            spactators: 'VIP Spectators',
            players: 'Players',
            duel: 'Duel',
            draft: 'Draft',
            of: 'of',
            signup: 'Sign up',
            requirements: `
                All the participants must be registered!<br />
                Each tournament is free to play.
              `,
          },
          ru: {
            header: 'Участники',
            staff: 'Персонал',
            spactators: 'VIP зрители',
            players: 'Игроки',
            duel: 'Дуэль',
            draft: 'Драфт',
            of: 'из',
            signup: 'Участвовать',
            requirements: `
                Все участники должны быть зарегистрированы.<br />
                Участие во всех турнирах бесплатное.
              `,
          },
        },
      })

      menu.participants = {
        name: computed(() => t('header')),
        icon: 'fa fa-user-friends',
      }

      return { modals, active, players, filteredPlayers, playersDuel, playersDraft, limitDuel, limitDraft, staff, spectators, t }
    },
  }
</script>

<style>
  .participants-enter-active,
  .participants-leave-active {
    transition: all 0.4s;
  }
  .participants-move {
    transition: transform 0.8s ease;
  }
  .participants-enter-from,
  .participants-leave-to {
    opacity: 0;
    transform: scale(0.5);
  }
  .participants-leave-active {
    position: absolute;
  }
</style>
